const ohioBounds = {north: 42, south: 38, west: -85, east: -80}

export default ohioBounds
